<template>
  <section class="games-filter">
    <div class="games-filter__categories">
      <q-btn
        :class="
          getButtonClasses(
            selectedCategory,
            null,
            'bg-secondary text-white',
            'bg-white text-black'
          )
        "
        class="games-filter__button"
        label="All"
        unelevated
        @click="handleCategoryChange(null)"
      />
      <q-btn
        v-for="(category, index) in categoryList"
        :key="index"
        :class="
          getButtonClasses(
            selectedCategory,
            category,
            'bg-secondary text-white',
            'bg-white text-black'
          )
        "
        class="games-filter__button"
        :label="category.CategoryName"
        unelevated
        @click="handleCategoryChange(category)"
      />
    </div>
    <div class="games-filter__queries">
      <q-input
        outlined
        v-model="searchTerm"
        label="Search Games"
        class="games-filter__input"
        debounce="500"
        clearable
        @input="handleSearchTermChange"
      >
        <template v-slot:prepend>
          <q-icon name="search" />
        </template>
      </q-input>
      <q-select
        color="secondary"
        class="games-filter__input"
        outlined
        v-model="providers"
        :options="providersList"
        option-value="id"
        option-label="ProviderName"
        map-options
        emit-value
        multiple
        label="Game Providers"
        clearable
        @input="handleProvidersChange"
      />
      <UserTypeSelector
        @userTypeChange="handleUserTypeChange"
        :storeGetter="userTypeStoreGetter"
        :storeSetter="userTypeStoreSetter"
      />
    </div>
  </section>
</template>

<script>
import UserTypeSelector from "@/components/filters/UserTypeSelector/";
export default {
  name: "AllGamesFilters",
  props: {
    categoryList: Array,
    currentCategory: Object,
    currentSearchTerm: String,
    providersList: Array,
    currentProviders: Array,
  },
  data() {
    return {
      providers: this.currentProviders,
      searchTerm: this.currentSearchTerm,
      selectedCategory: this.currentCategory,
    };
  },
  components: { UserTypeSelector },
  methods: {
    handleUserTypeChange(event) {
      this.$emit("userTypeChange", event);
    },
    handleProvidersChange(event) {
      this.$emit("providersChange", event);
    },
    handleSearchTermChange(event) {
      this.$emit("searchTermChange", event);
    },
    handleCategoryChange(event) {
      this.$emit("categoryChange", event);
    },
    getButtonClasses(selectedCategory, category, activeClass, inactiveClass) {
      if (category) {
        return selectedCategory &&
          selectedCategory.CategoryName === category.CategoryName
          ? activeClass
          : inactiveClass;
      }
      return !selectedCategory ? activeClass : inactiveClass;
    },
    userTypeStoreGetter() {
      return this.$store.getters.getUserTypeNew;
    },
    userTypeStoreSetter(payload) {
      return this.$store.commit("SET_USER_TYPE_NEW", {
        selectedUserTypeNew: payload,
      });
    },
  },
  watch: {
    currentCategory() {
      this.selectedCategory = this.currentCategory;
    },
    currentSearchTerm() {
      this.searchTerm = this.currentSearchTerm;
    },
    currentProviders() {
      this.providers = this.currentProviders;
    },
  },
};
</script>
